module.exports = __webpack_public_path__ + "assets/1d71843bdd4ba98ee7a4be43a4e293e6.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/rumble.mp3
 ** module id = 354
 ** module chunks = 0
 **/